import "ress/ress.css"
import "./src/styles/global.css"
import "./src/styles/colors.css"
import "./src/styles/typography.css"
import "./src/styles/shadows.css"
import "./src/styles/animations.css"

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (location.pathname !== prevLocation?.pathname && !location.hash) {
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" })
    })
  }
}
